import React, { useEffect, useState, useRef } from "react";
import { PiHandsClappingLight } from "react-icons/pi";
import { HiEllipsisVertical, HiChevronDown } from "react-icons/hi";
import chatSocketService from "../../services/websocket";
import { useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { CiCoffeeCup } from "react-icons/ci";
import axios from "axios";
import { Link } from "react-router-dom";
import { getVenueDetails } from "../../services/api";

function ChatScreenHeader() {
  const { venueUUID } = useParams();
  const [activeUsers, setActiveUsers] = useState(0);
  const [showUserList, setShowUserList] = useState(false);
  const [users, setUsers] = useState([]);
  const [showMenuPopup, setShowMenuPopup] = useState(false);
  const [showFeatureSlider, setShowFeatureSlider] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const swiperRef = useRef(null);
  const [clapEmojis, setClapEmojis] = useState([]);
  const [venueDetails, setVenueDetails] = useState(null);

  // Mekan detaylarını getiren useEffect
  useEffect(() => {
    const fetchVenueDetails = async () => {
      if (!venueUUID) {
        setVenueDetails(null);
        return;
      }

      try {
        const details = await getVenueDetails(venueUUID);
        setVenueDetails(details);
      } catch (error) {
        console.error("Mekan detayları alınırken hata:", error);
        // Geçersiz venue ID durumunda varsayılan değerler kullan
        setVenueDetails({
          name: "Mekan Bulunamadı",
          logo: "/assets/default-venue.png",
        });
      }
    };

    fetchVenueDetails();
  }, [venueUUID]);

  // Clap animasyonu için fonksiyon
  const handleClap = () => {
    const newEmojis = Array.from({ length: 8 }).map(() => ({
      id: Math.random().toString(36).substr(2, 9),
      top: Math.random() * 80 + 10,
      left: Math.random() * 80 + 10,
      rotate: Math.random() * 60 - 30,
    }));
    setClapEmojis(newEmojis);
    setTimeout(() => setClapEmojis([]), 1200);
  };

  useEffect(() => {
    if (venueUUID) {
      // Socket.io ile aktif kullanıcıları dinle
      const handleVenueUsers = (users) => {
        console.log("🔥 Header - Venue kullanıcıları güncellendi:", users);
        setActiveUsers(users.length);
        setUsers(
          users.map((user) => ({
            id: user.id,
            name: user.name || user.email || "Bilinmeyen Kullanıcı",
            avatar: user.avatar,
          }))
        );
      };

      // Socket bağlantısı varsa kullanıcı listesini dinle
      if (chatSocketService.connected) {
        const unsubscribe = chatSocketService.addUserListener(handleVenueUsers);
        return unsubscribe;
      } else {
        // Socket bağlantısını kur ve ardından dinlemeye başla
        chatSocketService
          .connect()
          .then(() => {
            if (chatSocketService.connected) {
              const unsubscribe =
                chatSocketService.addUserListener(handleVenueUsers);
              return unsubscribe;
            }
          })
          .catch((error) => {
            console.error("Socket bağlantı hatası (header):", error);
            setActiveUsers(0);
            setUsers([]);
          });
      }
    } else {
      setActiveUsers(0);
      setUsers([]);
    }
  }, [venueUUID]);

  return (
    <>
      <div className="absolute top-0 left-0 w-full z-20 flex items-center justify-between px-2 py-4 bg-transparent border-b border-transparent">
        {/* <div className="absolute top-4 left-4">
          <button
            onClick={() => setShowMenuPopup(!showMenuPopup)}
            className="w-10 h-8 rounded-xl flex items-center justify-center bg-white shadow-sm cursor-pointer shadow-black hover:bg-gray-50 transition-colors"
          >
            <EllipsisVerticalIcon className="h-5 w-5 text-black" />
          </button>
        </div> */}
        <div
          className="mx-auto flex justify-between px-2 items-center gap-2 shadow-gray-400 shadow-sm bg-white border-0 rounded-xl w-24 h-10 font-poppins cursor-pointer"
          // onClick={() => setShowUserList(!showUserList)} aktif kullanıcıları gösteren buton
          onClick={() => setShowMenuPopup(!showMenuPopup)}
        >
          <img src="/assets/userview.png" alt="user" className="w-5 h-4 pr-1" />
          <div className="text-black font-semibold text-lg font-poppins">
            {activeUsers}
          </div>
          <HiChevronDown className="text-gray-500 w-5 h-5" />
        </div>

        {/* Aktif Kullanıcılar Listesi */}
        {showUserList && (
          <div className="absolute top-16 left-1/2 transform -translate-x-1/2 bg-white rounded-xl shadow-lg p-4 min-w-[200px] z-50">
            <div className="text-sm font-semibold mb-2">
              Aktif Kullanıcılar ({users.length})
            </div>
            <div className="max-h-[200px] overflow-y-auto">
              {users.length > 0 ? (
                users.map((user) => (
                  <div key={user.id} className="flex items-center gap-2 py-1">
                    {user.avatar && (
                      <img
                        src={user.avatar}
                        alt={user.name}
                        className="w-5 h-5 rounded-full"
                      />
                    )}
                    {!user.avatar && (
                      <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                    )}
                    <span className="text-sm truncate" title={user.name}>
                      {user.name}
                    </span>
                  </div>
                ))
              ) : (
                <div className="text-sm text-gray-500">
                  Aktif kullanıcı bulunmuyor.
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Clap Emojileri Animasyonu */}

      {/* Menu Popup */}
      {showMenuPopup && (
        <div className="fixed inset-0 z-[51] flex items-center justify-center backdrop-blur-sm">
          <div className="relative bg-white rounded-3xl shadow-xl px-6 pt-16 pb-6 w-[90%] max-w-xs flex flex-col items-center animate-fade-in z-10">
            <div className="absolute -top-7 left-1/2 -translate-x-1/2 flex flex-col items-center">
              <div className="rounded-2xl px-6 py-2 flex flex-col items-center justify-center">
                <img
                  src={venueDetails?.logo || "/assets/qriendPhoneTanitim.png"}
                  alt="logo"
                  className="w-16 h-16 mb-1 object-cover rounded-2xl"
                />
              </div>
            </div>
            <div className="text-center flex flex-col items-center">
              <h2 className="text-xl font-semibold font-poppins text-black mb-2">
                {venueDetails?.name || "Yükleniyor..."}
              </h2>
              <p className="text-black max-w-[210px] font-poppins text-base mb-6">
                Uygulamayı indirerek QRiend'in diğer özelliklerinden yararlanın.
              </p>
              <div className="flex justify-center gap-2 mb-4">
                <a
                  href="https://apps.apple.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                    alt="App Store"
                    className="h-10"
                  />
                </a>
                <a
                  href="https://play.google.com/store"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                    alt="Google Play"
                    className="h-10"
                  />
                </a>
              </div>
              <button
                className="w-[220px] text-sm border border-gray-300 text-black rounded-full py-2 font-poppins hover:bg-gray-50 transition mb-2"
                onClick={() => setShowFeatureSlider(true)}
              >
                Mobil Uygulamanın Özellikleri
              </button>
              <button
                onClick={() => setShowMenuPopup(false)}
                className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 text-xl font-bold"
              >
                ×
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Feature Slider Modal */}
      {showFeatureSlider && (
        <div className="fixed inset-0 z-[51] flex items-center justify-center backdrop-blur-sm">
          <div className="relative bg-white rounded-3xl shadow-xl w-full h-full sm:max-w-[390px] sm:h-[700px] flex flex-col items-center animate-fade-in z-10 overflow-hidden">
            {/* Close Button only on 3rd slide */}
            {activeIndex === 2 && (
              <button
                onClick={() => setShowFeatureSlider(false)}
                className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 text-2xl font-bold z-20"
              >
                ×
              </button>
            )}
            <Swiper
              spaceBetween={30}
              slidesPerView={1}
              className="w-full h-full flex-1"
              onSwiper={(swiper) => (swiperRef.current = swiper)}
              onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
            >
              <SwiperSlide>
                <div
                  className="relative h-full w-full cursor-pointer"
                  onClick={() =>
                    swiperRef.current && swiperRef.current.slideNext()
                  }
                >
                  <div
                    className="absolute inset-0 w-full h-full bg-cover bg-no-repeat bg-center z-0"
                    style={{
                      backgroundImage: `url('/assets/chatSwiperOne.png')`,
                    }}
                  />
                  <div className="relative z-10 w-full flex flex-col items-center pt-8">
                    <h1 className="text-black text-center font-poppins text-xl font-semibold mb-12">
                      Mobil Uygulama Özellikleri
                    </h1>
                    <h3 className="text-[24px] max-w-[350px] font-semibold text-center mb-4 bg-gradient-to-b from-[#E94057] to-[#B62539] bg-clip-text text-transparent leading-tight">
                      Konum bazlı eşleme ile arkadaşlık bir adım uzaklıkta
                    </h3>
                    <p className="text-[#090A0A] text-center max-w-[330px]">
                      Uygulamayı indirdiğinde konum bazlı eşleşme sistemiyle
                      çevrende benzer hobileri olan insanları kolayca
                      bulabilirsin.
                    </p>
                  </div>
                  <div className="absolute bottom-0 left-0 w-full flex justify-center items-center gap-2 py-3 bg-white/80 z-10">
                    {[0, 1, 2].map((idx) => (
                      <button
                        key={idx}
                        className={`w-1/4 h-1 rounded transition-all duration-200 ${
                          activeIndex === idx ? "bg-[#E94057]" : "bg-gray-300"
                        } focus:outline-none`}
                        onClick={(e) => {
                          e.stopPropagation();
                          swiperRef.current && swiperRef.current.slideTo(idx);
                        }}
                        aria-label={`Go to slide ${idx + 1}`}
                      />
                    ))}
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  className="relative h-full w-full cursor-pointer"
                  onClick={() =>
                    swiperRef.current && swiperRef.current.slideNext()
                  }
                >
                  <div
                    className="absolute inset-0 w-full h-full bg-cover bg-no-repeat bg-center z-0"
                    style={{
                      backgroundImage: `url('/assets/chatSwiperTwo.png')`,
                    }}
                  />
                  <div className="relative z-10 w-full flex flex-col items-center pt-8">
                    <h1 className="text-black text-center font-poppins text-xl font-semibold mb-12">
                      Mobil Uygulama Özellikleri
                    </h1>
                    <h3 className="text-[24px] max-w-[350px] font-semibold text-center mb-4 bg-gradient-to-b from-[#E94057] to-[#B62539] bg-clip-text text-transparent leading-tight">
                      Qriend'in özel mekan chat sistemiyle sosyalleşmeyi yeniden
                      keşfet!
                    </h3>
                    <p className="text-[#090A0A] text-center max-w-[330px]">
                      Favori kafende aynı mekandaki insanlarla canlı grup
                      sohbetlerine katıl veya konum bazlı kategorilerde birebir
                      mesajlaş.
                    </p>
                  </div>
                  <div className="absolute bottom-0 left-0 w-full flex justify-center items-center gap-2 py-3 bg-white/80 z-10">
                    {[0, 1, 2].map((idx) => (
                      <button
                        key={idx}
                        className={`w-1/4 h-1 rounded transition-all duration-200 ${
                          activeIndex === idx ? "bg-[#E94057]" : "bg-gray-300"
                        } focus:outline-none`}
                        onClick={(e) => {
                          e.stopPropagation();
                          swiperRef.current && swiperRef.current.slideTo(idx);
                        }}
                        aria-label={`Go to slide ${idx + 1}`}
                      />
                    ))}
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  className="relative h-full w-full cursor-pointer"
                  onClick={() =>
                    swiperRef.current && swiperRef.current.slideNext()
                  }
                >
                  <div
                    className="absolute inset-0 w-full h-full bg-cover bg-no-repeat bg-center z-0"
                    style={{
                      backgroundImage: `url('/assets/chatSwiperThree.png')`,
                    }}
                  />
                  <div className="relative z-10 w-full flex flex-col items-center pt-8">
                    <h1 className="text-black text-center font-poppins text-xl font-semibold mb-12">
                      Mobil Uygulama Özellikleri
                    </h1>
                    <h3 className="text-[24px] font-semibold text-center mb-4 bg-gradient-to-b from-[#E94057] to-[#B62539] bg-clip-text text-transparent leading-tight">
                      Qriend'de benzersiz profilini yaratarak öne çık!
                    </h3>
                    <p className="text-[#090A0A] text-center max-w-[350px]">
                      Hobilerinle parla, favori mekanlarını paylaş ve seni
                      beğenenleri keşfet. Profilini kim takip ediyor? Hemen gör
                      ve tüm bunları göster!
                    </p>
                  </div>
                  <div className="absolute bottom-0 left-0 w-full flex justify-center items-center gap-2 py-3 bg-white/80 z-10">
                    {[0, 1, 2].map((idx) => (
                      <button
                        key={idx}
                        className={`w-1/4 h-1 rounded transition-all duration-200 ${
                          activeIndex === idx ? "bg-[#E94057]" : "bg-gray-300"
                        } focus:outline-none`}
                        onClick={(e) => {
                          e.stopPropagation();
                          swiperRef.current && swiperRef.current.slideTo(idx);
                        }}
                        aria-label={`Go to slide ${idx + 1}`}
                      />
                    ))}
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      )}
    </>
  );
}

export default ChatScreenHeader;
